export default __webpack_public_path__ + "static/media/c-sharp.ade1c29a.svg";